import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imTermDisplay', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/data-presentation/term-display/term-display.html'),
        controller: 'TermDisplayController',
        controllerAs: 'TermDisplayCtrl',
        bindings: {
            realizationDateFrom: '<',
            realizationDateTo: '<',
            priority: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/data-presentation/term-display/term-display.component.ts